import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMNS,
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE_BY_DENSITY,
  CARDS_GRID_ROW_SPACING,
} from '@app/components/base/content-structure/cards-grid-config';
import { GridListLabel } from '@app/components/base/content-structure/GridListLabel';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { MessageDescriptor } from 'react-intl';
import { FRAGMENT_LIST_CONTAINER_SX } from '../fragment-card/constants';
import { FragmentCard } from '../fragment-card/FragmentCardFactory';
import { useFragmentGridContext } from './FragmentGridContext';

/**
 * Renders a single date section: optional sticky label + fragment cards.
 * List view: single column, full width (max lg). Grid view: multi-column grid by viewMode.
 */
export const FragmentsListDateSection = memo(function FragmentsGridDateSection({
  titleMessage,
  showTitle,
  fragments,
}: {
  titleMessage: MessageDescriptor;
  showTitle: boolean;
  fragments: FragmentListItemDto[];
}) {
  const { viewMode } = useFragmentGridContext();

  if (!fragments.length) return null;

  return (
    <Box sx={{ mb: 6 }}>
      {showTitle && <GridListLabel message={titleMessage} />}
      {viewMode === 'list' ? (
        <Stack spacing={CARDS_GRID_ROW_SPACING} sx={FRAGMENT_LIST_CONTAINER_SX}>
          {fragments.map((fragment) => (
            <FragmentCard key={fragment.id} fragment={fragment} />
          ))}
        </Stack>
      ) : (
        <CardsGrid
          columns={CARDS_GRID_DENSE_COLUMNS}
          columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}
        >
          {fragments.map((fragment) => (
            <CardsGridItem size={CARDS_GRID_ITEM_SIZE_BY_DENSITY[viewMode]} key={fragment.id}>
              <FragmentCard fragment={fragment} />
            </CardsGridItem>
          ))}
        </CardsGrid>
      )}
    </Box>
  );
});
